import React from "react";
import { Typography, Card, CardContent, Box } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const DemographicsData = ({ data }) => {
  const demographicsChartData = [
    { name: "Total Guest Users", value: data?.totalGuestUsers || 0 },
    { name: "Total Dealers", value: data?.totalDealers || 0 },
    { name: "Active Users", value: data?.activeUsers || 0 },
    { name: "Total Drivers", value: data?.totalDrivers || 0 },
  ];

  // If all values are 0, create dummy 1-value to force rendering
  const isAllZero = demographicsChartData.every(item => item.value === 0);
  const displayData = isAllZero
    ? demographicsChartData.map((item, i) => ({
        ...item,
        value: 1, // dummy value to make chart visible
        realValue: 0, // used in label
      }))
    : demographicsChartData;

  return (
    <Card>
      <CardContent>
        <PieChart width={800} height={400}>
          <Pie
            data={displayData}
            cx="50%"
            cy="50%"
            outerRadius={120}
            dataKey="value"
            label={({ name, index }) => {
              const original = demographicsChartData[index];
              return `${name}: ${original.value}`;
            }}
          >
            {displayData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name, props) => {
              const original = demographicsChartData[props.index];
              return [`${original.value}`, name];
            }}
          />
          <Legend />
        </PieChart>
      </CardContent>
    </Card>
  );
};

export default DemographicsData;
